import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { RichTextParser } from '@PetSureAustralia/petsure-react-ui-library/distLib/helpers';
import classNames from 'classnames';
import { LogicalClaimPropTypes } from '../../../propTypes/claimDetails';
import { logicalClaimStatusMap } from '../claimDetails/claimStatusMap';
import './logicalClaimDetails.scss';
import { sanitizedAll } from '../../../utils/sanitize';
import { TooltipTrigger } from '../../tooltipTrigger/tooltipTrigger';
import { CLAIM_STATUS_CODES, LOGICAL_CLAIM_STATUS, PAYMENT_METHOD } from '../../../constants/constants';
import { useGetGeneralTooltipContentQuery } from '../../../data/kontentAi';
import { GENERAL_TOOLTIP_CODENAME } from '../../../constants/cmsCodeName';
import { FeatureFlagContext } from '../../../contextProviders/featureFlagContext';

export const LogicalClaimsDetails = ({ logicalClaim, petName, handleActionButtonClick, isUploadAdditionalDocs }) => {
  const { cspConfiguration } = useContext(FeatureFlagContext);
  const isKontentAiPreviewEnabled = cspConfiguration?.IsKontentAIPreviewEnabled || false;
  const { LogicalClaimNumber, LogicalClaimDescription, MethodOfReimbursement, Status, BenefitPaid, StatusCode } =
    logicalClaim;

  const sanitizedLogicalClaimDescription = sanitizedAll(LogicalClaimDescription);
  const contentByStatus = logicalClaimStatusMap({
    isUploadAdditionalDocs,
    statusCode: StatusCode,
    logicalClaimStatus: Status,
    benefitPaid: BenefitPaid
  });

  const isPaidByCheque =
    MethodOfReimbursement.toUpperCase() === PAYMENT_METHOD.CHEQUE &&
    BenefitPaid > 0 &&
    ((StatusCode === CLAIM_STATUS_CODES.CLAIM_PAID && Status === LOGICAL_CLAIM_STATUS.PAID) ||
      (StatusCode === CLAIM_STATUS_CODES.CLAIM_APPROVED && Status === LOGICAL_CLAIM_STATUS.APPROVED));

  const { data: generalTooltip } = useGetGeneralTooltipContentQuery(
    {
      previewEnabled: isKontentAiPreviewEnabled,
      element: [GENERAL_TOOLTIP_CODENAME.REIMBURSEMENT_UPDATE_TOOLTIP]
    },
    { skip: !isPaidByCheque }
  );
  const reimbursementUpdateTooltip =
    generalTooltip?.content?.[GENERAL_TOOLTIP_CODENAME.REIMBURSEMENT_UPDATE_TOOLTIP]?.[
      GENERAL_TOOLTIP_CODENAME.REIMBURSEMENT_UPDATE_TOOLTIP
    ]?.value || '';

  return (
    <div className="logicalClaimContainer">
      <section
        key={LogicalClaimNumber}
        className="logicalClaimDetailContainer"
      >
        <div>
          <p className="logicalClaimNumber">{LogicalClaimNumber}</p>
        </div>
        <div>
          <p>
            {sanitizedLogicalClaimDescription}
            &nbsp;
            {isPaidByCheque && (
              <TooltipTrigger
                id="reimbursement-update-tooltip"
                trigger={<Icon icon="information" />}
                content={<>{RichTextParser(reimbursementUpdateTooltip)}</>}
              />
            )}
            &nbsp;
            {contentByStatus?.inlineText && (
              <span>
                {contentByStatus?.inlineText({
                  onClick: (type) => handleActionButtonClick(type, LogicalClaimNumber),
                  petName
                })}
              </span>
            )}
          </p>
        </div>
        <div className="status">
          <span className={classNames('statusLabel', contentByStatus?.className)}>
            <Icon icon={contentByStatus?.icon} />
            &nbsp;
            {contentByStatus?.label}
          </span>
        </div>
      </section>
    </div>
  );
};

LogicalClaimsDetails.propTypes = {
  logicalClaim: PropTypes.shape(LogicalClaimPropTypes),
  petName: PropTypes.string,
  handleActionButtonClick: PropTypes.func,
  isUploadAdditionalDocs: PropTypes.bool
};
